import React, { useContext } from "react";
import NavBar from "../../components/general/NavBar";
import { Context, Data, Lead } from "../../components/Context";
import { IoMagnetOutline } from "react-icons/io5";
import { IoPeople } from "react-icons/io5";
import { IoStatsChartSharp } from "react-icons/io5";
import { GrHelpBook } from "react-icons/gr";
import { IoCalendarSharp } from "react-icons/io5";
import { IoOpenOutline } from "react-icons/io5";
import StatCard from "../../components/user/homeDashboard/StatCard";

const HomeDashboard = () : React.ReactElement => {
    const { workspace , loadDone, workspaceLeads, workspaceData, leadMagnets, user, workspaceABtests } = useContext(Context);
    return(
        <div className="h-screen">
            <NavBar pageName="Dashboard" pageDescription={`Overview of your ${(workspace)?workspace.workspace_name + " -":""}account`}/>
            {
                (loadDone)
                //Content for when loading is done
                ?<div>
                    {
                        ((!leadMagnets || leadMagnets.length === 0) || (!workspaceData || workspaceData.length === 0) || (!workspaceABtests || workspaceABtests.length === 0))
                        ?//Show onboarding materials
                        <div className="w-full p-5 flex flex-wrap gap-5 mb-10">
                            <div className="card shadow-md lg:w-[calc(60%-1.25rem)] w-full bg-brandLightGray">
                                <div className="card-body">
                                    <p>Hi {(user)? user.first_name :""},</p>
                                    <h2 className="card-title">Welcome to CX Tailor</h2>
                                    <p>Get started faster with our quick setup guide</p>
                                    <div className="w-full m-5">
                                        <ul className="steps steps-vertical w-4/5">
                                            <li className="step step-primary" data-content={`${"✓"}`}>
                                                <div className="text-left pt-5 pb-5">
                                                    <p className="text-lg">Register for free account</p>
                                                    <p className="text-sm">You can now start creating your own lead magnets using CX Tailor</p>
                                                </div>
                                            </li>
                                            <li className={`step ${(leadMagnets && leadMagnets.length > 0)?"step-primary":""}`} 
                                            data-content={`${(leadMagnets && leadMagnets.length > 0)?"✓":"2"}`}>
                                                <div className="text-left pt-5 pb-5">
                                                    <p className="text-lg">Create your first lead magnet</p>
                                                    <p className="text-sm">Use CX Tailors' funnel builder to create & publish your first lead magnet</p>
                                                </div>
                                            </li>
                                            <li className={`step ${(workspaceData && workspaceData.length > 0 
                                            && workspaceData.reduce((sum : number, next : any) =>  sum + next.steps14Days[0].view, 0) > 0)?"step-primary":""}`} 
                                            data-content={`${(workspaceData && workspaceData.length > 0 && workspaceData.reduce((sum : number, next : any) =>  sum + next.steps14Days[0].start) > 0)?"✓":"3"}`}>
                                                <div className="text-left pt-5 pb-5">
                                                    <p className="text-lg">Share your lead magnet</p>
                                                    <p className="text-sm">Start collecting data by embedding your lead magnet to your landing page, or by sharing it through a direct link</p>
                                                </div>
                                            </li>
                                            <li className={`step ${(workspaceABtests && workspaceABtests.length > 0)?"step-primary":""}`}
                                            data-content={`${(workspaceABtests && workspaceABtests.length > 0)?"✓":"4"}`}>
                                                <div className="text-left pt-5 pb-5">
                                                    <p className="text-lg">Start your first A/B-test</p>
                                                    <p className="text-sm">Optimize your funnel performance by running an A/B-test on your funnel</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="lg:w-[calc(40%-1.25rem)] w-full card">
                                <div className="flex flex-col p-5 m-5 gap-10">
                                    <p className="card-title">Need help getting started?</p>
                                    <div className="flex flex-col gap-4 p-2">
                                        <p className="flex flex-row justify-start items-center gap-2 text-xl">
                                            <GrHelpBook className="size-14 bg-green/30 text-green p-2 rounded-md"/> Documentation</p>
                                        <p>Explore our guide materials and find answers to your questions</p>
                                        <a href="https://cxtailor.helpscoutdocs.com/" rel="noreferrer" target="_blank" className="flex flex-row justify-start items-center text-brandPurple gap-2">
                                            <IoOpenOutline className="size-5"/>
                                            Open documentation
                                        </a>
                                    </div>
                                    <div className="flex flex-col gap-4 p-2">
                                        <p className="flex flex-row justify-start items-center gap-2 text-xl">
                                            <IoCalendarSharp className="size-14 bg-yellow/20 text-yellow p-2 rounded-md"/> Talk to an expert</p>
                                        <p className="text-black/60">Book a meeting with our conversion optimization specialists and get personalized help with building your first lead magnets.</p>
                                        <a href="https://meetings.hubspot.com/wihtori" rel="noreferrer" target="_blank" className="flex flex-row justify-start items-center text-brandPurple gap-2">
                                            <IoOpenOutline className="size-5"/>
                                            Talk to an expert
                                        </a> 
                                    </div>
                                </div>
                            </div>
                        </div>
                        :null
                    }
                    {
                        (workspaceLeads && workspaceData) 
                        ?<div className="w-full p-5 flex lg:flex-row max-lg:flex-col gap-5 mt-5">
                            <StatCard title="Lead Magnets" icon={<IoMagnetOutline className="size-10 text-brandLightGray"/>} iconColor="bg-brandPurple"
                            results={(leadMagnets)?Object.keys(leadMagnets).length : 0}/>
                            <StatCard title="Leads generated" icon={<IoPeople className="size-10 text-brandLightGray"/>} iconColor="bg-brandLightPurple" 
                            results={(workspaceLeads)?Object.keys(workspaceLeads).length : 0}/>
                            <StatCard title="Avg. Conversion" icon={<IoStatsChartSharp className="size-10 text-brandLightGray"/>} iconColor="bg-brandLightPurple" resultsEnd="%"
                            results={(workspaceData)?Number((workspaceData.reduce((sum : number, currentValue : any) => sum + currentValue.conversion14Days, 0) / workspaceData.length).toFixed(2)): 0}
                            comparisonResult={(workspaceData)?Number((workspaceData.reduce((sum : number, currentValue : any) => sum + currentValue.conversionComparison, 0) / workspaceData.length).toFixed(2)): 0}
                            />
                        </div>
                        :<div className="w-full p-5 flex lg:flex-row max-lg:flex-col gap-5 mt-5">
                            <div className="skeleton lg:w-1/5 max-lg:w-full h-32"></div>
                            <div className="skeleton lg:w-1/5 max-lg:w-full h-32"></div>
                            <div className="skeleton lg:w-1/5 max-lg:w-full h-32"></div>
                        </div>
                    }
                    <div className="xl:w-3/4 p-5 pt-1">
                        <h2 className="m-5 text-lg">Top performing funnels:</h2>
                        <table className="table bg-brandLightGray shadow-md">
                            <thead className="border-b-2">
                                <tr className="text-lg">
                                    <th className="w-[10%]"></th>
                                    <th className="w-[33%]">Funnel</th>
                                    <th>Steps</th>
                                    <th>Start rate</th>
                                    <th>Conversion rate</th>
                                </tr>
                            </thead>
                            {
                                (workspaceData)
                                ?<tbody>
                                    {workspaceData.slice(0,5).map((data : Data, idx : number) => {
                                        return<tr key={idx} className="hover:bg-brandLightPurple hover:text-brandLightGray cursor-pointer">
                                                <td>{idx + 1}</td>
                                                <td>{data.name}</td>
                                                <td>{data.steps14Days.length}</td>
                                                <td>{(data.steps14Days[0].view)?(data.steps14Days[0].start / data.steps14Days[0].view * 100).toFixed(1):0} %</td>
                                                <td>{(data.conversion14Days)?data.conversion14Days:0} %</td>
                                            </tr>
                                    })}
                                </tbody>
                                :<tbody>
                                    {[...Array(5)].map((idx: number) => {
                                        return<tr>
                                                <td><span className="skeleton w-full h-full"></span></td>
                                                <td><span className="skeleton w-full h-full"></span></td>
                                                <td><span className="skeleton w-full h-full"></span></td>
                                                <td><span className="skeleton w-full h-full"></span></td>
                                            </tr>
                                    })}
                                </tbody>
                            }
                        </table>
                    </div>
                    <div className="xl:w-3/4 p-5 pt-1 mb-5">
                        {
                            (loadDone && workspaceLeads && workspaceLeads.length > 0)
                            ?<table className="table bg-brandLightGray shadow-md">
                                <thead className="border-b-2">
                                    <tr className="text-lg">
                                        <th className="w-[10%]"></th>
                                        <th className="w-[25%]">Name</th>
                                        <th className="w-[25%]">Email</th>
                                        <th className="w-[25%]">Became a lead</th>
                                        <th className="w-[15%]">Quality</th>
                                    </tr>
                                </thead>
                                {
                                    (workspaceLeads.length > 0)
                                    ?<tbody>
                                    {workspaceLeads.slice(0,5).map((lead : Lead, idx : number) => {
                                        return<tr key={idx} className="hover:bg-brandLightPurple hover:text-brandLightGray cursor-pointer">
                                                <td>{idx + 1}</td>
                                                <td>{lead.firstName} {lead.lastName}</td>
                                                <td>{lead.email}</td>
                                                <td>{lead.created_at}</td>
                                                <td>{lead.quality}</td>
                                            </tr>
                                    })}
                                </tbody>
                                :null
                                }
                            </table>
                            :null
                        }
                    </div>   
                </div>
                //Content for when loading is still happening
                :<div>
                    <span className="loading loading-spinner text-primary"></span>
                </div>
            }
        </div>
    );
};

export default HomeDashboard;